
import { form17StatusInfoType } from '@/types/Information/Form17';
import { Component, Prop, Vue } from 'vue-property-decorator';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form17ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form17StatusInfoType;

}
